import React from 'react';
import styled, { css } from 'styled-components';
import abbreviate from 'number-abbreviate';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 40px;

  @media (max-width: 1024px) {
    margin: 40px 0 -20px;
  }

  ${({ $showOn }) => $showOn === 'mobile' && css`
    @media (min-width: 1024px) { display: none; }
  `}

  ${({ $showOn }) => $showOn === 'desktop' && css`
    @media (max-width: 1024px) { display: none; }
  `}
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

const Description = styled.h1`
  position: relative;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.less.textColor};
  opacity: 0.5;
  line-height: 1;
`;

const Value = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.less.secondaryColor};
  line-height: 1;
`;

const Stats = ({ data, $showOn }) => (
  <Wrapper $showOn={$showOn}>
    <Column>
      <Description>Page Views</Description>
      <Value>{abbreviate(data?.pageviews, 1)}</Value>
    </Column>
    <Column>
      <Description>Unique Visitors</Description>
      <Value>{abbreviate(data?.visitors, 1)}</Value>
    </Column>
    <Column>
      <Description>Time on Page</Description>
      <Value>
        {data?.secondsOnPage > 60
          ? `${Math.round(data?.secondsOnPage / 60)}min`
          : `${data?.secondsOnPage}s`}
      </Value>
    </Column>
  </Wrapper>
);

export default Stats;
